import {
  Placeholder,
  FormAttributes,
  UserRoleElement,
  UserRoleAttrubutes,
  Role,
} from './user-role.interface';
import { FormPlaceholders, RequestType } from './user-role.details';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { regex } from '../../common/regex.constants';
import {
  ApiUserRequestParams,
  ApiPermissionRequestParams,
} from './user-role.interface';

type ApiRequestParams = ApiUserRequestParams | ApiPermissionRequestParams;

export class UserRoleModel {
  /**
   *@var error to store error status
   **/
  public error: any;
  /**
   *@var _placeholders  to store placeholders in the form's label
   **/
  private _placeholders: Placeholder;
  /**
   *@var _formData to store user role
   **/
  private _userData: Array<UserRoleElement>;
  /**
   *@var _requestAttriutes to store request values in the model
   **/
  private _requestAttriutes: ApiRequestParams;
  /**
   *@var _formRoleAttriutes to store form values in the model
   **/
  private _roleAttriutes: FormAttributes;
  /**
   *@var to store default value of fields.
   **/
  private _userRoles: UserRoleAttrubutes;
  constructor() {
    this._placeholders = FormPlaceholders;
    this._userData = [];
    
  }
  /**
   * formGetRole returns A collection of form controls. The key is the name under which it is registered in the form.
   * value here is default values and set of validators
   **/
  get formGetRole(): { [key: string]: Array<any> } {
    return {
      userEmail: [
        null,
        [Validators.required, Validators.pattern(regex.emailPattern)],
      ],
    };
  }
  /**
   * formUpdateRole returns A collection of form controls. The key is the name under which it is registered in the form.
   * value here is default values and set of validators
   **/
  get formUpdateRole(): { [key: string]: Array<any> } {
    return {
      userEmail: [{ value: false, disabled: true }, [Validators.nullValidator]],
      userType: [{ value: "" }, [Validators.nullValidator]],
      roles: [{ value: [] }, [Validators.nullValidator]],
    };
  }
  /**
   * placeholder returns the placeholder
   **/
  get placeholder(): Placeholder {
    return this._placeholders;
  }
  /**
   * formData set user role data
   **/
  set userData(_formData: Array<UserRoleElement>) {
    this._userData = _formData;
  }
  /**
   * formData returns user role data
   **/
  get userData(): Array<UserRoleElement> {
    return this._userData;
  }
  /**
   * setRequestAttributes set to form attributes from formgroup
   **/
  public setRequestAttributes(attributes: UntypedFormGroup, type: string) {
    switch (type) {
      case RequestType.getUserRoles:
        this._requestAttriutes = Object.create({
          type: type,
          headers: [
            {
              name: 'user-email',
              value: !!attributes.getRawValue().userEmail ? attributes.getRawValue().userEmail.toLowerCase() : '',
            },
          ],
          body: null,
        } as ApiRequestParams);
        break;
      case RequestType.updateUserRoles:
      case RequestType.createUserRoles:
        this._requestAttriutes = Object.create({
          type: type,
          headers: null,
          body: {
            userEmail: !!attributes.getRawValue().userEmail ? attributes.getRawValue().userEmail.toLowerCase() : '',
            roleIDs: attributes.value.roles
              .filter((role) => !!role.allowed)
              .map((role) => role.roleID),
            userType: attributes.value.userType,
          },
        } as ApiRequestParams);
        break;
      case RequestType.getUserPermissions:
        break;
      case RequestType.updateUserPermissions:
        break;
      default:
        this._requestAttriutes = Object.create({
          type: null,
          headers: null,
          body: null,
        } as ApiRequestParams);
    }
  }
  /**
   * requestAttributes get call when form attributes are required
   **/
  get requestAttributes(): ApiRequestParams {
    return this._requestAttriutes;
  }
  /**
   * clearFormAttributes call that required to clear form attributes as empty
   **/
  public clearRequestAttributes() {
    this._requestAttriutes = Object.create({} as ApiRequestParams);
  }

  public get userRoles(): UserRoleAttrubutes {
    return this._userRoles;
  }

  public set userRoles(userRoleAttrs: UserRoleAttrubutes) {
    this._userRoles = userRoleAttrs;
  }

  /**
 * updateUserRoles call that union given user roles  with default roles
 **/
  public updateUserRoles(role_list: Array<Role>) {
    const roles: Array<Role> = role_list.map(
      (role: Role): Role => {
        return {
          roleName: role.roleName,
          roleID: role.roleID,
          placeholder: role.roleName.replace(/_/g, ' '),
          allowed: !!this.userRoles.roles.find(
            (userRole: Role) => userRole.roleName === role.roleName
          ),
        } as Role;
      }
    );
    this.userRoles.roles = roles;
  }
}
